import { hanger } from './objects/hanger';
import { bow } from './objects/bow';
import { candle } from './objects/candle';
import { spring } from './objects/spring';
import { kettle } from './objects/kettle';
import { balloon } from './objects/balloon';
import { bulb } from './objects/bulb';
import { rocket } from './objects/rocket';
import { umbrella } from './objects/umbrella';
import { fan } from './objects/fan';
import { hourglass } from './objects/hourglass';
import { lamp } from './objects/lamp';
import { pencil } from './objects/pencil';
import { magnifier } from './objects/magnifier';
import { kite } from './objects/kite';
import { bell } from './objects/bell';

/** Objects bodies, in picker order. */
export const OBJECTS_BODIES = {
  hanger,
  bow,
  candle,
  spring,
  kettle,
  balloon,
  bulb,
  rocket,
  umbrella,
  fan,
  hourglass,
  lamp,
  pencil,
  magnifier,
  kite,
  bell,
};
